<div class="grid-2col input-grid-gaps">
    <app-date-input [formField]="formDef.periodFrom" [label]="prefix + 'periodFrom'"></app-date-input>
    <app-date-input [formField]="formDef.periodTo" [label]="prefix + 'periodTo'"></app-date-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonLoading]="store.loadingAny()"
        [primaryButtonDisability]="store.loadingAny()"
        [secondaryButtonDisability]="store.loadingAny()"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
